import HTTP from "./http.service";

var Protection = {};
Protection.getOTP = (number) => {
  let config = {
    method: "post",
    url: "/fraud/check_customer_with_otp",
    data: number,
  };
  return HTTP(config);
};

Protection.verifyOTP = (data) => {
  let config = {
    method: "post",
    url: "/complaints/verify_otp",
    data: data,
  };
  return HTTP(config);
};

Protection.reportSpamCall = (payload) => {
  let config = {
    method: "post",
    url: "/fraud/report_fraud",
    data: payload,
  };
  return HTTP(config);
};

Protection.getFraudTypeId = () => {
  let config = {
    method: "get",
    url: "/fraud/types",
  };
  return HTTP(config);
};

Protection.submitFraudSurveyFeedback = (payload) => {
  let config = {
    method: "post",
    url: "/fraud/submit_fraud_survey_feedback",
    data: payload,
  };
  return HTTP(config);
};

export default Protection;
